module.exports = __webpack_public_path__ + "static/media/german-colors-all.222ab1d5.PNG";